// extracted by mini-css-extract-plugin
module.exports = {"list":"OfficeDocuments_list__3gA_4","upload":"OfficeDocuments_upload__1LW0O","uploadButton":"OfficeDocuments_uploadButton__3rVz0","smallTitle":"OfficeDocuments_smallTitle__3wysn"};